import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateObligationImpactMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateObligationImpactDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateObligationImpactInput = {
  Id: string;
  Description: string;
  ImpactRating: number;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateObligationImpact = createMutationHook({
  name: 'updateObligationImpact',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligationImpact.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateObligationImpactInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.obligationImpact.getByParentId.queryKey(),
    trpc.frontend.obligationImpact.getById.queryKey(),
    // COI-471 parity: Apollo twin also evicts `obligation`.
    trpc.frontend.obligation.pathKey(),
  ],
  mapResponse: (): UpdateObligationImpactMutation => ({
    update_obligation_impact: {
      __typename: 'obligation_impact_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateObligationImpactDocument,
  graphqlVariables: (input: UpdateObligationImpactInput) => ({
    id: input.Id,
    Description: input.Description,
    ImpactRating: input.ImpactRating,
    CustomAttributeData: input.CustomAttributeData ?? null,
  }),
  evictFields: ['obligation_impact', 'obligation'],
});
